var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlogs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0072b2;}.cls-2{fill:#00a0df;}.cls-3{fill:#71c2ea;}.cls-4{fill:#cfeaff;}.cls-5,.cls-8{fill:none;stroke-width:10px;}.cls-5{stroke:#71c2ea;stroke-miterlimit:10;}.cls-6{fill:gray;}.cls-7{fill:#febe10;}.cls-8{stroke-linecap:round;stroke-linejoin:round;opacity:0.65;stroke:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 299.74,
    y1: 311.41,
    x2: 299.74,
    y2: 145.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#fff",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#fff",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#fff",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#fff",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#fff",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#fff",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_141",
    "data-name": "Layer 141"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300,265.33s-88.22-40.15-153.91-52.88A590.14,590.14,0,0,0,9.76,202.19,10.22,10.22,0,0,0,0,212.44V558.89a8.06,8.06,0,0,0,8.64,8,807.07,807.07,0,0,1,123.1.81C198.06,573.26,300,600,300,600Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300,265.34s88.22-40.15,153.91-52.88A590.14,590.14,0,0,1,590.24,202.2,10.22,10.22,0,0,1,600,212.45V558.9a8.06,8.06,0,0,1-8.64,8,807.07,807.07,0,0,0-123.1.81C401.94,573.27,300,600,300,600Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300,587.89H272.78v4.66a21.46,21.46,0,0,0,4.27,3.93c3.94,2.73,7.8,3.41,22.95,3.52,15.15-.11,19-.79,22.95-3.52a21.46,21.46,0,0,0,4.27-3.93v-4.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M448.56,199.69a549.07,549.07,0,0,0-144.88,51.25,8,8,0,0,1-7.36,0,549.07,549.07,0,0,0-144.88-51.25A547.62,547.62,0,0,0,18.07,189.45a8,8,0,0,0-7.64,8V543.87a8,8,0,0,0,8.48,8,741.8,741.8,0,0,1,278.57,36.76,8,8,0,0,0,5,0,741.8,741.8,0,0,1,278.57-36.76,8,8,0,0,0,8.48-8V197.44a8,8,0,0,0-7.64-8A547.62,547.62,0,0,0,448.56,199.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M319,579.37a21.39,21.39,0,0,1-38,0V572h38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M411.89,169.06A485.92,485.92,0,0,0,304,214.54a8,8,0,0,1-7.9,0A485.9,485.9,0,0,0,46.6,150.48a8,8,0,0,0-7.87,8V510.34a8,8,0,0,0,7.82,8,724.4,724.4,0,0,1,97.38,8.78A726.16,726.16,0,0,1,297.05,569a8,8,0,0,0,5.9,0,724.28,724.28,0,0,1,250.5-50.71,8,8,0,0,0,7.82-8V158.48a8,8,0,0,0-7.87-8A487.67,487.67,0,0,0,411.89,169.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M313.78,563.81a14.7,14.7,0,0,1-27.82,0v-6.4h27.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M436.31,125.59a391.15,391.15,0,0,0-131.89,56.62,8,8,0,0,1-8.84,0,391.15,391.15,0,0,0-131.89-56.62,389.28,389.28,0,0,0-90.19-9.31,8,8,0,0,0-7.88,8V476.35a8,8,0,0,0,7.6,8,490.22,490.22,0,0,1,89,12.48A491.46,491.46,0,0,1,296,550.05a8,8,0,0,0,8,0,489.58,489.58,0,0,1,222.78-65.71,8,8,0,0,0,7.6-8V124.28a8,8,0,0,0-7.88-8A389.28,389.28,0,0,0,436.31,125.59Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 300,
    y1: 185.21,
    x2: 300,
    y2: 552.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "lightbulb"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M362.83,361.05a14.38,14.38,0,0,0-12.12-14.19,14,14,0,0,0,11.65-13.78V318.31H236.7v14.77a14,14,0,0,0,12.12,13.86,14.38,14.38,0,0,0,2.73,28.49h1.27a14.37,14.37,0,0,0,3.24,28.38h7.22v.09a14.38,14.38,0,0,0,14.38,14.38h45.19a14.38,14.38,0,0,0,14.38-14.38v-.09h6.68a14.37,14.37,0,0,0,3.24-28.38h1.3A14.38,14.38,0,0,0,362.83,361.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M450.71,157.25c5.69-46.53-18.51-92.85-51.62-120.79C359.36,2.92,313.74,1.69,299.35,1.93c-14.76-.22-60,1.25-99.41,34.53-33.11,27.94-57.32,74.26-51.62,120.79,3.52,28.83,17.7,51,20.07,54.65,16.31,25,32.47,29.79,48.75,54.65a131.81,131.81,0,0,1,19.56,51.77H362.32c0-.18.06-.35.08-.53a131.85,131.85,0,0,1,19.48-51.24c16.28-24.87,32.44-29.67,48.75-54.64C433,208.27,447.18,186.08,450.71,157.25Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M270.05,306.41c1.12-14.66-3.75-58.18-9.57-82.37A191.3,191.3,0,0,0,228,154.73a40.13,40.13,0,0,0,21.29,3.83c11.1-1.27,12.93-6.89,23-7.56,12.61-.84,14.41,7.6,27.38,7.11,11.59-.43,12.68-7.26,24.34-7.11,9.15.12,11.29,4.36,21.72,6.22,7,1.25,15.52,1,25.63-2.49a318.57,318.57,0,0,0-28.38,68.42,321.78,321.78,0,0,0-12.17,83.26"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogs);
export default __webpack_public_path__ + "static/media/blogs.8c63b84d3f523adbe386a9b574924934.svg";
export { ForwardRef as ReactComponent };